var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M28.5 14.47c0 1.213-1.017 2.196-2.27 2.196H21.69c-.57 0-1.092-.204-1.49-.54a2.162 2.162 0 01-.78-1.656h-4.004v21.042h17.097V14.47H28.5zm-7.885-2.455c0-1.964 1.693-3.508 3.385-3.508 1.692 0 3.385 1.544 3.385 3.508h5.077c1.401 0 2.538 1.194 2.538 2.666v20.64c0 1.472-1.137 2.666-2.538 2.666H15.538c-1.401 0-2.538-1.194-2.538-2.667V14.681c0-1.472 1.137-2.666 2.538-2.666h5.077zM22.077 12h3.692c0-1.105-.826-2-1.846-2s-1.846.895-1.846 2z", fill: "currentColor", fillRule: "nonzero", stroke: "none", strokeWidth: 1 })));
});
